<template>
<modal name="yagioffer-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeYagiOfferDialog"
      icon="el-icon-circle-close-outline"
      style="font-size: 2rem;"
      type="text"></el-button>
  </div>
  <div class="setting" v-if="permissionType == 1">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 140%;">ヤギオファーに登録</p>
      <br>
      <p style="font-size: 110%;">※求人会社から提案を受けるには履歴書作成が必要です</p>
      <br>
      <p style="font-size: 110%;padding-bottom:10px;">希望勤務地：
          <el-select v-model="hopeAreaPref"
            placeholder="選択してください">
            <el-option v-for="item in prefOptions"
              :key="item"
              :label="item"
              :style="item"
              :value="item"></el-option>
          </el-select>
      </p>
      <p style="font-size: 110%;padding-bottom:10px;">希望業界：
          <el-select v-model="hopeIndustry"
            placeholder="選択してください">
            <el-option v-for="item in hopeIndustryOptions"
              :key="item"
              :label="item"
              :style="item"
              :value="item"></el-option>
          </el-select>
      </p>
      <p style="font-size: 110%;padding-bottom:10px;">希望職種：
          <el-select v-model="hopeJobcategory"
            placeholder="選択してください">
            <el-option v-for="item in hopeJobcategoryOptions"
              :key="item"
              :label="item"
              :style="item"
              :value="item"></el-option>
          </el-select>
      </p>
      <p style="font-size: 110%;padding-bottom:10px;">学部・学科：
          <el-input class="input-md"
                      placeholder="学部・学科を入力してください"
                      title="学部・学科"
                      v-model="department"></el-input>
      </p>
      <p style="font-size: 110%;">卒業年度：
          <el-select v-model="graduationYear"
            placeholder="選択してください">
            <el-option v-for="item in graduationYearOptions"
              :key="item"
              :label="item"
              :style="item"
              :value="item"></el-option>
          </el-select>
      </p>
      <br>
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link><br/>
      </p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 120%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意してヤギオファーに登録する
        </p>
      </div>
      <div class="text-center" style="padding:10px">
        <el-button id="send-yagioffer" type="success" v-if="isYagiOfferSended == false"
        style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-yagioffer-consult');">登録する</el-button>
        <br/>
      </div>
    </div>
  </div>

</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      hopeAreaPref: '',
      hopeIndustry: '',
      hopeJobcategory: '',
      previewHtml: '',
      department: '',
      graduationYear: '',
      permissionType: 1,
      isYagiOfferSended:false,
      isMedlySended:false,
      isAdtopSended:false,
      isJigenSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:true,
      departmentOptions:['法学・政策系', '経済・経営系', '商学系', '社会・福祉系', '国際関係系', '外国語系', '文学系', '教員養成系', '教育系', '家政系', '宗教・神学系', '体育・芸術・音楽系', '商船系', '理系', '医療・保健系', '数理物系', '機械系', '電気・電子・制御系', '情報系', '応用物系', '土木系', '建築系', '生物系', '化学・物質系', '金属系', 'その他理工系', '農業・農学系', '水産系', '畜産・酪農系', '薬学系', '医学・歯学系', '獣医系', '衛生・医療・介護系'],
      graduationYearOptions:['23年卒', '24年卒', '25年卒'],
      hopeIndustryOptions:['IT・通信', 'ソフトウェア・情報処理', 'インターネット関連・ゲーム・アプリ関連', '機械・産業用装置・電機・OA機器', '自動車・自動車部品・輸送用機器', 'コンピュータ・通信機器・精密機器', '電子部品・半導体', '食品・飲料・たばこ・飼料', '化学・医薬・化粧品', '鉄鋼・非鉄金属・金属製品', '石油・石炭・ゴム・プラスチック', 'ガラス・セラミック・セメント', 'パルプ・紙・紙加工・印刷・印刷関連', '日用品・文具・オフィス用品', '建材・エクステリア', 'インテリア・住宅関連', 'アパレル・服飾関連', 'スポーツ・玩具・ゲーム機器', 'その他メーカー・製造関連', '電気・ガス・石油・水道', '放送（テレビ・ラジオ含む）', '新聞・出版', '広告', 'その他（芸能・エンタテインメント関連等）', '運輸（鉄道・航空・海運・物流等）', '総合商社', '専門商社', '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター', '通信販売、専門店・その他小売り', '銀行（協同組織金融含む）', '証券', '保険', 'その他金融（クレジット等）', 'リース・レンタル', 'ディベロッパー', '建設・建築設計・ハウスメーカー', '設備関連', 'プラント・プラントエンジニアリング', '不動産取引・不動産賃貸・不動産管理', 'デザイン・芸術関連', 'コンサルティング・マーケティング・調査', 'その他専門・技術サービス', 'ホテル・旅館', '外食', 'その他フード', '理美容・エステ・フィットネスクラブ', '旅行・観光', '家事サービス・クリーニング', '冠婚葬祭', 'その他生活関連サービス', 'アミューズメント・レジャーサービス', '教育関連', '医療・保育・介護、福祉', '環境・リサイクル・廃棄物処理', '整備・修理', '人材サービス', 'その他事業サービス（警備、コールセンター等）', 'その他'],
      hopeJobcategoryOptions:[' 営業', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業'],
      prefOptions: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'],
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openYagiOfferDialog: function (id, html, permissionType) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('yagioffer-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'yagioffer_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', '')
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeYagiOfferDialog: function () {
      this.$modal.hide('yagioffer-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendYagiOfferConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'yagioffer_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendYagiOffer, formData, {timeout: 60000})
        .then(function (response) {
          app.isYagiOfferSended = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-yagioffer-consult', this.sendYagiOfferConsult)
    this.$eventHub.$on('open-yagioffer-dialog', this.openYagiOfferDialog)
    this.$eventHub.$on('popstate', this.closeYagiOfferDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-yagioffer-consult', this.sendYagiOfferConsult)
    this.$eventHub.$off('open-yagioffer-dialog', this.openYagiOfferDialog)
    this.$eventHub.$off('popstate', this.closeYagiOfferDialog)
  }
}
</script>
